import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const API_BASE_URL = process.env.REACT_APP_API_URL;


export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const [userRole, setUserRole] = useState('');

  // 📌 Cargar usuario desde `localStorage` al cargar la página
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    console.log("Usuario recuperado en useEffect:", storedUser); // 📌 Depuración

    if (storedUser && storedUser.id) {
      setIsLoggedIn(true);
      setUserId(storedUser.id); // ✅ Recuperar correctamente el ID
      setUserEmail(storedUser.email);
      setToken(storedUser.token);
      setUserRole(storedUser.role);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      formData.append("password", password);

      const response = await fetch(`${API_BASE_URL}/api/users/authenticate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: formData.toString(),
      });

      if (!response.ok) {
        throw new Error("Credenciales inválidas");
      }

      const data = await response.json();
      console.log("Respuesta del servidor en login:", data); // 📌 Depuración

      if (!data.authenticated) {
        throw new Error("Autenticación fallida");
      }

      setIsLoggedIn(true);
      setUserId(data.id); // ✅ Guardar correctamente el ID
      setUserEmail(email);
      setToken(data.token);
      setUserRole(data.role);

      // Guardar en `localStorage`
      localStorage.setItem("user", JSON.stringify({
        id: data.id, // ✅ `id` correctamente almacenado
        email,
        role: data.role,
        token: data.token, 
        authenticated: data.authenticated,
      }));

      console.log("Usuario guardado en localStorage:", JSON.parse(localStorage.getItem("user"))); // 📌 Depuración

      return { success: true, role: data.role };
    } catch (error) {
      console.error("Error en autenticación:", error);
      return { success: false, message: error.message };
    }
  };

  // 📌 Cerrar sesión
  const logout = () => {
    setIsLoggedIn(false);
    setUserId(null); // ✅ Limpiar `userId`
    setUserEmail('');
    setToken(null);
    setUserRole('');
    localStorage.removeItem("user"); // ✅ Eliminar usuario de localStorage
    localStorage.removeItem("token"); // ✅ Asegurar que el token también se elimina    
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userId, userEmail, token, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
